import { AuthPayload } from "@/interfaces/ui.interface"

export default {
  setAuth(state: any, payload: AuthPayload) {
    state.responseAuth = payload
  },
}